// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__xJEWF","formSection":"ContactForm_formSection__Xsm5h","otherInfoInput":"ContactForm_otherInfoInput__rr9wh","submitButton":"ContactForm_submitButton__arYGd"};